<template>
  <div class="wrapper">
    <div class="container">
      <div class="title-page">
        <h1>Bienvenue,</h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" @click.prevent="GoToDashboard"><a>Accueil</a></li>
            <li class="breadcrumb-item active" aria-current="page">Mon compte</li>
          </ol>
        </nav>
      </div>

      <div class="row account-layout">
        <div class="col-lg-3 col-md-12 sidebar-column">
          <MenuSidebar :activeTab="activeTab" @change-tab="changeTab" />
        </div>

        <div class="col-lg-9 col-md-12 content-column">
          <div class="content-wrapper">
            <component :is="currentComponent" v-if="currentComponent" class="tab-content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuSidebar from "@/components/MenuSidebar.vue";
  import TableauBordView from "@/views/supplyvet/TableauBordView.vue";
  import MesContactsView from "@/views/supplyvet/MesContactsView.vue";
  import InformationsPersonnelsView from "@/views/supplyvet/InformationsPersonnelsView.vue";
  import AdresseLivraisonView from "@/views/supplyvet/AdresseLivraisonView.vue";
  import CommandesView from "@/views/supplyvet/CommandesView.vue";
  import FacturesView from "@/views/supplyvet/FacturesView.vue";
  import DocumentsView from "@/views/supplyvet/DocumentsView.vue";
  import CalculRationView from "@/views/supplyvet/CalculRationView.vue";
  import ParametresCalculView from "@/views/supplyvet/ParametresCalculView.vue";
  import RappelView from "@/views/supplyvet/RappelView.vue";
  import CommandesClientView from "@/views/supplyvet/CommandesClientView.vue";
  import FactureClientView from "@/views/supplyvet/FactureClientView.vue";
  import Catalogue from "@/views/supplyvet/Catalogue.vue";
  import FraisPort from "@/views/supplyvet/FraisPort.vue";
  import Presentation from "@/views/supplyvet/Presentation.vue";
  import OffreFidelite from "@/views/supplyvet/OffreFidelite.vue";
  import Communication from "@/views/supplyvet/Communication.vue";
  import MollieStatusView from "@/views/supplyvet/MollieStatusView.vue";
  import { useProductsStore } from "@/stores/productsStore";

  export default {
    components: {
      MenuSidebar,
      TableauBordView,
      MesContactsView,
      InformationsPersonnelsView,
      AdresseLivraisonView,
      CommandesView,
      FacturesView,
      DocumentsView,
      CalculRationView,
      ParametresCalculView,
      RappelView,
      CommandesClientView,
      FactureClientView,
      Catalogue,
      FraisPort,
      Presentation,
      OffreFidelite,
      Communication,
      MollieStatusView,
    },
    data() {
      return {
        activeTab: "informations_personnels",
        tabComponents: {
          
          mes_contacts: "MesContactsView",
          informations_personnels: "InformationsPersonnelsView",
          adresse_livraison: "AdresseLivraisonView",
          commandes: "CommandesView",
          factures: "FacturesView",
          documents: "DocumentsView",
          calcul_ration: "CalculRationView",
          parametres_calcul: "ParametresCalculView",
          rappel: "RappelView",
          commandes_clients: "CommandesClientView",
          facture_clients: "FactureClientView",
          catalogue: "Catalogue",
          frais_port: "FraisPort",
          offre_fidelete: "OffreFidelite",
          presentation: "Presentation",
          communication: "Communication",
          mollie_status: "MollieStatusView",
        },
      };
    },
    computed: {
      currentComponent() {
        return this.tabComponents[this.activeTab] || null;
      },
    },
    mounted() {
      const tabFromQuery = this.$route.query.tab;
      if (tabFromQuery && this.tabComponents[tabFromQuery]) {
        this.activeTab = tabFromQuery;
      }
    },
    watch: {
      "$route.query.tab"(newTab) {
        if (newTab && this.tabComponents[newTab]) {
          this.activeTab = newTab;
        }
      },
    },
    methods: {
      changeTab(tab) {
        this.activeTab = tab;
        if (this.$route.query.tab !== tab) {
          this.$router.replace({
            name: this.$route.name,
            query: { ...this.$route.query, tab },
          });
        }
      },
      handleSubmit() {
        this.form.name = "";
      },
      Logout() {
        localStorage.clear();
        const productsStore = useProductsStore();
        localStorage.removeItem("token");

        productsStore.$reset();
        localStorage.removeItem("products");
        localStorage.clear();
        this.$router.push({ name: "Home" });
      },
      openDropdown() {
        this.isOpen = true;
      },
      closeDropdown() {
        this.isOpen = false;
      },
      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
    },
  };
</script>

<style scoped>
/* Styles spécifiques pour la responsivité de la page mon compte vétérinaire */
.account-layout {
  min-height: calc(100vh - 200px);
}

.sidebar-column {
  position: relative;
}

.content-column {
  position: relative;
}

.content-wrapper {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px;
  min-height: 400px;
}

.tab-content {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive pour tablettes */
@media (max-width: 991px) {
  .account-layout {
    flex-direction: column;
  }
  
  .sidebar-column {
    order: 1;
    margin-bottom: 20px;
  }
  
  .content-column {
    order: 2;
  }
  
  .content-wrapper {
    padding: 15px;
  }
}

/* Responsive pour mobile */
@media (max-width: 767px) {
  .wrapper {
    padding: 10px;
  }
  
  .container {
    padding: 0;
  }
  
  .title-page {
    text-align: center;
    margin-bottom: 15px;
  }
  
  .title-page h1 {
    font-size: 20px;
    margin-bottom: 8px;
  }
  
  .breadcrumb {
    justify-content: center;
    font-size: 12px;
  }
  
  .content-wrapper {
    padding: 12px;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .sidebar-column {
    margin-bottom: 15px;
  }
}

/* Responsive pour très petits écrans */
@media (max-width: 575px) {
  .wrapper {
    padding: 5px;
  }
  
  .title-page h1 {
    font-size: 18px;
  }
  
  .breadcrumb {
    font-size: 11px;
  }
  
  .content-wrapper {
    padding: 10px;
  }
}

/* Amélioration de l'accessibilité */
.title-page h1:focus,
.breadcrumb a:focus {
  outline: 2px solid var(--blue);
  outline-offset: 2px;
  border-radius: 4px;
}

/* Amélioration pour les composants dynamiques */
.tab-content > * {
  width: 100%;
}

/* Optimisation pour les tableaux et formulaires */
.tab-content :deep(table) {
  font-size: 14px;
}

.tab-content :deep(.form-control) {
  font-size: 14px;
}

@media (max-width: 767px) {
  .tab-content :deep(table) {
    font-size: 12px;
  }
  
  .tab-content :deep(.form-control) {
    font-size: 13px;
  }
  
  .tab-content :deep(.btn) {
    font-size: 13px;
    padding: 6px 12px;
  }
}
</style>
